export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  heroCulture: "https://images.pexels.com/photos/36696494/pexels-photo-36696494.jpeg",
  cultureDancing:
    "https://images.unsplash.com/photo-1742095228943-1b0ceb0fd82e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxoYWl0aSUyMGN1bHR1cmUlMjBtdXNpY3xlbnwwfHx8fDE3ODcxMTgwMjh8MA&ixlib=rb-4.1.0&q=85",
  president: "/president.webp",
  icdhStudents: "https://images.pexels.com/photos/8618019/pexels-photo-8618019.jpeg",
  fblaLeadership:
    "https://images.unsplash.com/photo-1744320911030-1ab998d994d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxibGFjayUyMHlvdXRoJTIwc3R1ZGVudHMlMjBncm91cHxlbnwwfHx8fDE3ODcxMTgwMzd8MA&ixlib=rb-4.1.0&q=85",
  fbla1: "/fbla1.jpg",
  fbla2: "/fbla2.webp",
  fbla3: "/fbla3.webp",
  fbla4: "/fbla4.webp",
};

export const DONATION_TIERS = [
  { id: "seed", amount: 25 },
  { id: "supporter", amount: 50 },
  { id: "advocate", amount: 100 },
  { id: "patron", amount: 250 },
  { id: "benefactor", amount: 500 },
];
